export const colors = {
  mainBlue: '#0369AA',
  mainGrey: '#6b7280',
  errorRed: '#b71c1c',
}
